import { Skeleton, type SkeletonProps } from '@mui/material';
import type { FC } from 'react';

export type ThemedSkeletonProps = SkeletonProps & {
  colorVariant?: 'primary' | 'secondary';
};

export const ThemedSkeleton: FC<ThemedSkeletonProps> = ({ colorVariant = 'primary', sx, ...props }) => {
  const backgroundColor =
    colorVariant === 'secondary' ? 'var(--tgui--secondary_bg_color)' : 'var(--tg-theme-section-bg-color)';
  return <Skeleton {...props} sx={{ bgcolor: backgroundColor, ...sx }} />;
};
